import { CSSProperties, ChangeEvent } from 'react';
import { ReactComponent as AddFileIcon } from 'assets/icons/addFile.svg';
import { StyledInput, Wrapper } from './AddFileHeaderButton.style';

const AddFileHeaderButton = ({
    onChange
}: {
    onChange: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
    styles?: CSSProperties;
}) => {
    return (
        <Wrapper>
            <StyledInput htmlFor='addFile'>
                <AddFileIcon />
                Dodaj plik
                <input
                    type='file'
                    id='addFile'
                    name='addFile'
                    onChange={onChange}
                    multiple
                    accept='.png, .jpg, .jpeg, .bmp, .tif, .tiff, .gif, .pdf'
                />
            </StyledInput>
        </Wrapper>
    );
};

export default AddFileHeaderButton;
